import React from 'react';
import { Route, RouteProps, Redirect, useLocation } from 'react-router-dom';

import { AuthRoutes } from '../utils/constants';

interface PrivateRouteProps extends RouteProps {
  component: React.ComponentType<any>;
  isAuthenticated: boolean;
}

type Props = PrivateRouteProps;

//TODO: see here for full implementation
// https://github.com/ElementAI/underwriting-intelligence/blob/master/underwriting-webapp/src/routers/PrivateRoute.tsx

// Keeps `/` and `:` literal (legal in a query value); every other reserved character is encoded.
const encodeStartUrl = (url: string): string => encodeURIComponent(url).replace(/%2F/gi, '/').replace(/%3A/gi, ':');

const PrivateRoute = (props: Props) => {
  const { component: Component, isAuthenticated, location, ...rest } = props;
  const locationUrl = useLocation();

  return (
    <Route
      {...rest}
      render={(props): JSX.Element =>
        isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect to={
            `${AuthRoutes.Login}?startUrl=${encodeStartUrl(locationUrl.pathname + (location?.search ?? ''))}`
          } />
        )
      }
    />
  );
};

export default PrivateRoute;
